import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Avatar,
    Divider,
    Card,
    CardContent,
    Paper,
} from "@mui/material";

const About = () => {
    return (
        <Box sx={{ 
            // bgcolor: "#000",
            // background  : "linear-gradient(to bottom left, #7AB2D3, #ffffff )",
            background  : "linear-gradient(to bottom right, #7AB2D3, #8ae97d )",
            py: 10,
            }}>
            <Container maxWidth="lg">
                {/* Heading */}
                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        fontWeight: 800,
                        color: "#fff",
                        mb: 5,
                        textTransform: "uppercase",
                        letterSpacing: 2,
                    }}
                >
                    About Us
                </Typography>

                {/* About Image Centered */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 6,
                        objectFit: 'contain',

                    }}
                >
                    <Avatar
                        variant="rounded"
                        alt="Our Team"
                        // src="/images/about.jpg"
                        src="/images/about1.jpg"
                        sx={{
                            width: { xs: "100%", md: "70%" },
                            height: { xs: 200, md: 400 },
                            boxShadow: 6,
                            borderRadius: 4,
                            "& img": {
                                objectFit: "contain",
                                width: "100%",
                                height: "100%",
                                textAlign: "center",
                                color: "transparent",
                                textIndent: "10000px",
                            },
                        }}
                    />

                </Box>

                {/* Who We Are Card */}
                <Card
                    sx={{
                        backgroundColor: "#ffffff",
                        borderRadius: 4,
                        p: 4,
                        mb: 6,
                        boxShadow: 4,
                    }}
                >
                    <CardContent>
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700, color: "#4A628A", mb: 2,fontFamily:'Merriweather, serif', }}
                        >
                            Who We Are
                        </Typography>
                        <Typography sx={{ fontSize: 16, lineHeight: 1.9, color: "#333" }}>
                            Claysoft Solutions is a growing IT company that provides smart and reliable software services to businesses across the globe.
                            From new start-ups to large organizations, we help our clients work faster and smarter with the right technology.

                            <br /><br />
                            With years of experience, we’ve built long-term relationships with our clients by delivering quality solutions,
                            24/7 support, and access to skilled experts using the latest tools and techniques.
                        </Typography>
                    </CardContent>
                </Card>

                {/* Vision and Mission Section */}
                <Grid container spacing={4}>
                    {/* Vision */}
                    <Grid item xs={12} md={6}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 4,
                                borderRadius: 4,
                                height: "100%",
                                background: "#E3F6F5",
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 700, color: "#4A628A", mb: 2 ,fontFamily:'Merriweather, serif',}}
                            >
                                Our Vision
                            </Typography>
                            <Typography sx={{ fontSize: 16, color: "#333", lineHeight: 1.9 }}>
                                To become a trusted global leader in delivering simple, smart, and secure software solutions that empower businesses of all sizes to grow, operate efficiently, and stay ahead in a technology-driven world.
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Mission */}
                    <Grid item xs={12} md={6}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 4,
                                borderRadius: 4,
                                height: "100%",
                                background: "#F8F6F4",
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 700, color: "#4A628A", mb: 2 ,fontFamily:'Merriweather, serif',}}
                            >
                                Our Mission
                            </Typography>
                            <Typography component="ul" sx={{ pl: 3, color: "#333" }}>
                                <li>To build reliable and easy-to-use software products that solve real business challenges.</li>
                                <li>To deliver customized IT solutions that match the exact needs of our clients — from planning to execution.</li>
                                <li>To ensure data security, seamless integration, and user-friendly experiences in every product we offer.</li>
                                <li>To support our clients with 24/7 technical expertise and build long-term partnerships based on trust and innovation.</li>
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default About;
